import { css } from '@emotion/core'
import ReactJson from 'react-json-view'
import React from 'react'
import PropTypes from 'prop-types'
import { DmcExpander } from './DmcExpander'

export default () => {}
const justForTesting = css`
  display: none;
`

/**
 * This component is used for debugging and testing reducer's state
 */
export function RawData({ state, testId, viewJson = false, collapsed = 1, noExpander = false }) {
  testId = testId || 'getStateForTests'
  const body = <ReactJson src={state} collapsed={collapsed} displayDataTypes={false} />

  return (
    <>
      {viewJson && (noExpander ? body : <DmcExpander header="Raw Data" body={body} />)}
      <div css={justForTesting} data-testid={testId}>
        {JSON.stringify(state)}
      </div>
    </>
  )
}

RawData.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object,
  testId: PropTypes.string,
  viewJson: PropTypes.bool,
}
